import { baseApi } from "./base.api";

export const settingsApi = baseApi.injectEndpoints({
  endpoints: (build) => ({
    fetchLatestWebsiteSettings: build.query({
      query: () => ({ url: "/settings/fetch/latest", method: "GET" }),
      providesTags: ["WebsiteSetting"],
    }),
    saveWebsiteSettings: build.mutation({
      query: (body) => ({ url: "/settings/save", method: "POST", body }),
      invalidatesTags: ["WebsiteSetting"],
    }),
  }),
});

export const {
  useFetchLatestWebsiteSettingsQuery,
  useSaveWebsiteSettingsMutation,
} = settingsApi;
